(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.getElementById('Sec-{{ section.id }}');
  if (!root) return;
  root.querySelectorAll('img.hb__img').forEach(img=>{
    if(!img.getAttribute('alt')){ img.setAttribute('alt',''); img.setAttribute('aria-hidden','true'); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-bestsellers"] && !Shopify.designMode) return;
  try {
    
(() => {
  const SECTION_SELECTOR = '.bestsellers-carousel-container';
  const DOTS_SELECTOR = '.carousel-dots';

  function getCardsToShow() {
    const w = window.innerWidth;
    if (w < 750) return 1;
    if (w < 990) return 2;
    if (w < 1200) return 3;
    return 4;
  }

  function init(container) {
    const viewport = container.querySelector('.bestsellers-carousel');
    const cards = Array.from(container.querySelectorAll('.bestseller-card'));
    const prevBtn = container.querySelector('.carousel-btn-prev');
    const nextBtn = container.querySelector('.carousel-btn-next');
    const dotsHost = container.parentElement.querySelector(DOTS_SELECTOR);

    if (!viewport || cards.length === 0) return;

    let currentPage = 0;
    let isScrolling = false;
    let startX = 0;
    let scrollLeft = 0;

    function totalPages() {
      return Math.max(1, Math.ceil(cards.length / getCardsToShow()));
    }

    function viewportWidth() { return viewport.clientWidth; }

    function gotoPage(i, smooth = true) {
      currentPage = Math.max(0, Math.min(i, totalPages() - 1));
      viewport.scrollTo({ left: currentPage * viewportWidth(), behavior: smooth ? 'smooth' : 'auto' });
      updateUI();
    }

    function buildDots() {
      dotsHost.innerHTML = '';
      const pages = totalPages();
      
      // Si solo hay una página, no mostrar dots
      if (pages <= 1) {
        dotsHost.style.display = 'none';
        return;
      }
      
      dotsHost.style.display = 'flex';
      for (let i = 0; i < pages; i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'dot';
        b.setAttribute('aria-label', `Ir a página ${i + 1}`);
        b.setAttribute('aria-current', String(i === 0));
        b.addEventListener('click', () => gotoPage(i));
        dotsHost.appendChild(b);
      }
    }

    function updateUI() {
      const dots = dotsHost.querySelectorAll('button.dot');
      dots.forEach((d, i) => d.setAttribute('aria-current', String(i === currentPage)));
      prevBtn.disabled = currentPage === 0;
      nextBtn.disabled = currentPage >= totalPages() - 1;
      
      // Si solo hay una página, ocultar flechas automáticamente
      const pages = totalPages();
      if (pages <= 1) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
      } else {
        // Respetar la configuración de ocultar flechas
        const section = container.closest('.bestsellers-section');
        const hideArrows = section && section.dataset.hideArrows === 'true';
        prevBtn.style.display = hideArrows ? 'none' : '';
        nextBtn.style.display = hideArrows ? 'none' : '';
      }
    }

    prevBtn.addEventListener('click', () => gotoPage(currentPage - 1));
    nextBtn.addEventListener('click', () => gotoPage(currentPage + 1));

    // Mejorar detección de scroll
    let scrollTimeout;
    function onScroll() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const page = Math.round(viewport.scrollLeft / viewportWidth());
        if (page !== currentPage) {
          currentPage = page;
          updateUI();
        }
      }, 100);
    }
    viewport.addEventListener('scroll', onScroll, { passive: true });

    // Touch handling mejorado para mobile
    const cardLinks = viewport.querySelectorAll('.card-link');
    
    cardLinks.forEach(link => {
      let touchStartX = 0;
      let touchStartY = 0;
      let touchStartTime = 0;
      
      link.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchStartTime = Date.now();
      }, { passive: true });
      
      link.addEventListener('touchend', (e) => {
        const touchEndX = e.changedTouches[0].clientX;
        const touchEndY = e.changedTouches[0].clientY;
        const touchEndTime = Date.now();
        
        const deltaX = Math.abs(touchEndX - touchStartX);
        const deltaY = Math.abs(touchEndY - touchStartY);
        const deltaTime = touchEndTime - touchStartTime;
        
        // Si es un swipe (más de 10px de movimiento horizontal), prevenir click
        if (deltaX > 10 || deltaTime > 200) {
          e.preventDefault();
        }
        // Si es tap rápido (menos de 200ms y menos de 10px), permitir navegación
      });
    });

    let rTimer;
    function onResize() {
      clearTimeout(rTimer);
      rTimer = setTimeout(() => {
        const old = currentPage;
        buildDots();
        gotoPage(old, false);
      }, 150);
    }
    window.addEventListener('resize', onResize);

    buildDots();
    gotoPage(0, false);

    document.addEventListener('shopify:section:unload', (evt) => {
      if (evt.detail.sectionId !== '{{ section.id }}') return;
      viewport.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
    });
  }

  function boot() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(init);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wfi-footer"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Encapsulado. No globals.
  // La separación entre íconos usa márgenes para permitir valores negativos y 0 sin romper el layout.
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wfi-producto-destacado"] && !Shopify.designMode) return;
  try {
    
(() => {
  const onUnload = () => {};
  document.addEventListener('shopify:section:unload', onUnload, { passive: true });
})();

  } catch(e) { console.error(e); }
})();
})();
